import { render, staticRenderFns } from "./invoice.vue?vue&type=template&id=253461c4&scoped=true"
import script from "./invoice.vue?vue&type=script&lang=js"
export * from "./invoice.vue?vue&type=script&lang=js"
import style0 from "./invoice.vue?vue&type=style&index=0&id=253461c4&prod&lang=scss&scoped=true"
import style1 from "./invoice.vue?vue&type=style&index=1&id=253461c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253461c4",
  null
  
)

export default component.exports